import { useSuspenseQuery } from "@tanstack/react-query";
import { unwrap } from "@majourneys/api-client";
import { useBookingContext } from "../provider";

const activityAvailabilityKeys = {
  availability: (slug: string, date: string) =>
    ["activities", "availability", slug, date] as const,
};

export function useAvailability(slug: string, date: string) {
  const { api } = useBookingContext();
  return useSuspenseQuery({
    queryKey: activityAvailabilityKeys.availability(slug, date),
    queryFn: async () =>
      unwrap(await api.activities.explore({ slug }).times.get({ query: { date } })),
  });
}
